var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('v-main',[_c('v-sheet',{staticClass:"mx-auto pa-3 pa-md-12 mt-3 mt-md-12 mb-12",attrs:{"max-width":"1000"}},[_c('router-view')],1)],1),(_vm.$route.name !== 'Caisse')?_c('PanierDrawer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }